// extracted by mini-css-extract-plugin
export var avatar = "comment-item-module--avatar--07232";
export var comment = "comment-item-module--comment--61f89";
export var commentBox = "comment-item-module--comment-box--c3018";
export var content = "comment-item-module--content--32ba4";
export var date = "comment-item-module--date--87d81";
export var moveIn = "comment-item-module--move-in--9aa6e";
export var name = "comment-item-module--name--16e44";
export var separator = "comment-item-module--separator--e643e";